import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Activity, Loader2 } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("medico@vitalsync.com");
  const [password, setPassword] = useState("medico123");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-background">
      <div className="hidden lg:flex flex-col justify-between p-12 bg-primary text-primary-foreground relative overflow-hidden">
        <div className="flex items-center gap-2">
          <div className="w-10 h-10 rounded-lg bg-primary-foreground/15 flex items-center justify-center">
            <Activity className="w-6 h-6" strokeWidth={2.5} />
          </div>
          <span className="font-heading font-extrabold text-xl">LIA</span>
        </div>
        <div className="max-w-md">
          <h2 className="font-heading text-4xl font-light tracking-tighter leading-tight mb-4">
            Inteligência <span className="text-ai font-semibold">Aplicada</span> à Saúde.
          </h2>
          <p className="text-primary-foreground/70 leading-relaxed">
            Um ecossistema que conecta laboratórios (LIA Lab), clínicas e médicos (LIA Clínica) e
            pacientes (LIA Saúde). A IA correlaciona exames, imagens e wearables e acompanha a evolução
            do paciente.
          </p>
          <p className="text-ai font-medium mt-4">A inteligência que conecta toda a saúde.</p>
        </div>
        <p className="text-xs text-primary-foreground/50">
          Uso educativo. Não substitui avaliação médica profissional.
        </p>
      </div>

      <div className="flex items-center justify-center p-6 sm:p-12">
        <form onSubmit={submit} className="w-full max-w-sm space-y-6 animate-fade-up" data-testid="login-form">
          <div>
            <h1 className="font-heading text-3xl font-bold tracking-tight">Entrar</h1>
            <p className="text-muted-foreground text-sm mt-1">Acesse o painel — médico ou paciente.</p>
          </div>

          <div className="space-y-2">
            <Label htmlFor="email">E-mail</Label>
            <Input id="email" type="email" value={email} data-testid="login-email"
              onChange={(e) => setEmail(e.target.value)} required />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Senha</Label>
            <Input id="password" type="password" value={password} data-testid="login-password"
              onChange={(e) => setPassword(e.target.value)} required />
          </div>

          {error && <p className="text-sm text-destructive" data-testid="login-error">{error}</p>}

          <Button type="submit" className="w-full" disabled={loading} data-testid="login-submit">
            {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />} Entrar
          </Button>

          <p className="text-sm text-muted-foreground text-center">
            Não tem conta?{" "}
            <Link to="/register" className="text-primary font-medium hover:underline" data-testid="link-register">
              Cadastre-se
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
}
